import { useTranslation } from "react-i18next";
import { currency } from "../../../../../dynamicController";

const LaundroVending = ({ amount, setAmount, machine, minusAmount, addAmount, handleSubmit, user, discountCode, voucherId, setDiscountCodeModal, discountCodeDiscountAmount, setOpen, point, setPoint, discountText, getPaymentAmount, isOpen, removeVoucher, renderVouchers }) => {

    const { t } = useTranslation();

    return (
        <div>
            <h6 style={{ margin: "20px 0 5px 0" }}>
                <strong>{t("Select Payment Amount")}</strong>
            </h6>

            <div className="payment-amount">
                <span id="minus-amount" onClick={e => minusAmount()}>
                    <i className="bi bi-dash-circle-fill"></i>
                </span>

                <div>
                    <h6 className="m-0 p-0 font-weight-bold text-secondary">{t("AMOUNT TO PAY")}</h6>
                    {
                        machine.type === "Billacceptor" ? (
                            <div className="d-flex">
                                <h3 className="m-0 p-0 font-weight-bold">{currency(machine.country)}</h3>
                                <input type="number" id="amount" name="amount" className="ms-2 form-control browser-default text-center" value={amount} onChange={e => setAmount(e.target.value)} required min="0" max="100" step={machine.step || 1} />
                            </div>
                        ) : (
                            <h3 className="m-0 p-0 font-weight-bold">{currency(machine.country)} {/\./g.test(amount.toString()) ? parseFloat(amount).toFixed(2) : amount}</h3>
                        )
                    }
                </div>

                <span id="add-amount" onClick={e => addAmount()}>
                    <i className="bi bi-plus-circle-fill"></i>
                </span>
            </div>

            <div className="list-group payment-list-group">
                <div className="list-group-item payment-list-group-item">
                    <div>
                        <p className="text-secondary">{t("PRICE")}</p>
                    </div>

                    <div>
                        <p>{currency(machine.country)} {/\./g.test(amount.toString()) ? parseFloat(amount).toFixed(2) : amount}</p>
                    </div>
                </div>

                {user && (machine.type === "Vending Machine" || machine.type === "Detergent Vending" || machine.type === "Car Wash") ? (
                    <div>
                        {(discountCode || !voucherId) ? (
                            <div className="list-group-item payment-list-group-item align-items-center">
                                <div>
                                    <p className="text-secondary">{t("DISCOUNT CODE")}</p>
                                </div>

                                <div>
                                    <button
                                        id="select-voucher"
                                        type="button"
                                        onClick={(e) => setDiscountCodeModal(true)}
                                        className="text-secondary"
                                        style={{
                                            border: "none",
                                            backgroundColor: "white",
                                            outline: "none",
                                            fontWeight: "bold",
                                            paddingRight: "0px",
                                            fontSize: "large",
                                        }}
                                    >
                                        {discountCode && discountCodeDiscountAmount
                                            ? `${discountCode} (${discountText("Discountcode")})`
                                            : t("Enter code >")}
                                    </button>
                                </div>
                            </div>
                        ) : null}

                        {(voucherId || !discountCode) ? (
                            <div className="list-group-item payment-list-group-item align-items-center">
                                <div>
                                    <p className="text-secondary">{t("VOUCHER")}</p>
                                </div>

                                <div>
                                    <button
                                        id="select-voucher"
                                        type="button"
                                        onClick={(e) => setOpen(true)}
                                        className="text-secondary"
                                        style={{
                                            border: "none",
                                            backgroundColor: "white",
                                            outline: "none",
                                            fontWeight: "bold",
                                            paddingRight: "0px",
                                            fontSize: "large",
                                        }}
                                    >
                                        {voucherId ? discountText("Voucher") : t("Select Voucher >")}
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : null}

                {
                    user && user.loyalty_point && (machine.type === "Vending Machine" || machine.type === "Detergent Vending" || machine.type === "Car Wash") ? (
                        <div className="list-group-item payment-list-group-item align-items-center">
                            <div>
                                <p className="text-secondary">{user.loyalty_point_name} ({user.point})</p>
                            </div>

                            <div className="toggle-switch">
                                <input type="checkbox" className="toggle-switch-checkbox" name="point" id="point" checked={point} onChange={e => setPoint(!point)} />
                                <label className="toggle-switch-label" htmlFor="point">
                                    <span className="toggle-switch-inner" />
                                    <span className="toggle-switch-switch" />
                                </label>
                            </div>
                        </div>
                    ) : null
                }

                {
                    point ? (
                        <div className="list-group-item payment-list-group-item">
                            <div>
                                <p className="text-secondary">{user.loyalty_point_name}</p>
                            </div>

                            <div>
                                <p className="text-secondary">{getPaymentAmount("pointAmount")} {user.loyalty_point_name} ({currency(machine.country)} {getPaymentAmount("pointValue")})</p>
                            </div>
                        </div>
                    ) : null
                }

                <div className="list-group-item payment-list-group-item">
                    <div>
                        <p style={{ fontSize: "24px", fontWeight: "bolder" }} className="text-secondary">
                            {t("TOTAL")}
                        </p>
                    </div>

                    <div>
                        <p style={{ fontSize: "24px", fontWeight: "bolder" }}>{currency(machine.country)} {getPaymentAmount("paymentAmount")}</p>
                    </div>
                </div>
            </div>

            <div className="mt-5 px-3">
                <button id="pay" onClick={e => handleSubmit(e)} className="btn form-control big-button">
                    {t("PAY")}
                </button>
            </div>

            {user ? (
                <div>
                    <div
                        onClick={(e) => setOpen(false)}
                        className={isOpen ? "custom-overlay isOpen" : "custom-overlay"}
                    ></div>
                    <div className={isOpen ? "custom-modal isOpen" : "custom-modal"}>
                        <div className="custom-modal-header">
                            {voucherId ? (
                                <button
                                    id="remove-voucher"
                                    onClick={(e) => removeVoucher()}
                                    type="button"
                                    className="custom-modal-title m-0 p-0"
                                    style={{
                                        color: "red",
                                        border: "none",
                                        backgroundColor: "white",
                                        margin: 0,
                                        padding: 0,
                                    }}
                                >
                                    <i className="bi bi-slash-circle"></i> {t("Remove Voucher")}
                                </button>
                            ) : (
                                <h6 className="custom-modal-title">
                                    <i className="bi bi-tags-fill"></i> {t("Select Your Voucher")}
                                </h6>
                            )}
                        </div>

                        <div className="custom-modal-body">
                            <ul className="list-group list-group-flush px-4">
                                {renderVouchers()}
                            </ul>
                        </div>
                    </div>
                </div>
            ) : null}

        </div>
    )
}

export default LaundroVending;